import { render } from "./TwitchMessages.vue?vue&type=template&id=12566a62&scoped=true"
import script from "./TwitchMessages.vue?vue&type=script&lang=js"
export * from "./TwitchMessages.vue?vue&type=script&lang=js"

import "./TwitchMessages.vue?vue&type=style&index=0&id=12566a62&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12566a62"]])

export default __exports__